import { useTranslation } from "react-i18next";

import { RoleLink } from "@/components/role-link";
import { useWorkerUpcomingQuery } from "@/queries/hooks/workerDashboardHooks";

import { UpcomingShiftCard } from "../../dashboard/-components/worker-v2/upcoming-shifts";

/** Enough to cover every upcoming shift a worker realistically holds; the dashboard shows 3. */
const MAX_SHIFTS = 100;

/** Worker "My shifts": every upcoming shift (offered / applied / approved / confirmed), soonest first. */
export function WorkerShiftsList() {
  const { t } = useTranslation("shifts");
  const { data, isLoading, isError } = useWorkerUpcomingQuery(MAX_SHIFTS);
  const shifts = data?.items;

  return (
    <section className="max-w-[1100px] mx-auto px-5 py-8 flex flex-col gap-4">
      <h1 className="heading-2">{t("list.myUpcomingShifts", "My upcoming shifts")}</h1>

      {isLoading ? (
        <div className="grid gap-3 md:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-40 rounded-[15px] bg-white border border-fog-dark animate-pulse" />
          ))}
        </div>
      ) : isError ? (
        <p className="text-sm text-slate">{t("list.loadFailed", "Couldn't load your shifts. Please try again.")}</p>
      ) : !shifts || shifts.length === 0 ? (
        <p className="text-sm text-slate">
          {t("list.noUpcomingShifts", "You have no upcoming shifts.")}{" "}
          <RoleLink to="/app/$role/dashboard" className="text-teal no-underline!">
            {t("list.findShifts", "Find shifts near you")}
          </RoleLink>
        </p>
      ) : (
        <div className="grid gap-3 md:grid-cols-3">
          {shifts.map((s) => (
            <UpcomingShiftCard key={s.shift_id} shift={s} />
          ))}
        </div>
      )}
    </section>
  );
}
